var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lightRate"},[_c('titlePage',{attrs:{"item":_vm.title}}),_c('div',{staticClass:"lightRate-box"},[_c('chartsLine',{attrs:{"option":_vm.lineData,"id":"lightRateBox"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }